var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#E61500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25947 3.34375C6.25947 3.34375 5.45963 3.60923 4.83803 4.08879C4.55247 4.3091 4.33051 4.50372 4.00261 4.86814C2.54167 6.58416 2.43536 9.08211 3.81555 10.8775C3.99695 11.1187 4.20807 11.3437 4.20807 11.3437H6.65798L6.95252 10.9705C6.95252 10.9705 6.05664 10.8016 5.26721 10.0386C4.03808 8.82928 4.06199 7.50798 4.19318 6.78753C4.20125 6.7432 4.27888 6.0111 4.90886 5.21159C5.03615 5.05005 5.26007 4.83544 5.42755 4.77234C5.58785 4.72297 5.76994 4.76446 5.87337 5.0092L7.7932 11.1197H7.99969H8.20617L10.126 5.0092C10.2294 4.76446 10.4115 4.72297 10.5718 4.77234C10.7393 4.83544 10.9632 5.05005 11.0905 5.21159C11.7205 6.0111 11.7981 6.7432 11.8062 6.78753C11.9374 7.50798 11.9613 8.82928 10.7322 10.0386C9.94274 10.8016 9.04685 10.9705 9.04685 10.9705L9.34139 11.3437H11.7913C11.7913 11.3437 12.0024 11.1187 12.1838 10.8775C13.564 9.08211 13.4577 6.58416 11.9968 4.86814C11.6689 4.50372 11.4469 4.3091 11.1613 4.08879C10.5397 3.60923 9.7399 3.34375 9.7399 3.34375L7.99969 8.89165L6.25947 3.34375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetro);
export default __webpack_public_path__ + "static/media/metro.cd8cd92165559e52d6d55107866f35b4.svg";
export { ForwardRef as ReactComponent };